<script>
import _debounce from 'lodash/debounce'
import setWindowHistory from "@utils/window-history";

export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return ['string']
      }
    },
    name: {
      type: String,
      default: 'filterName'
    },
    type: {
      type: String,
      default: 'prompt',
      validator(value) {
        return [
          'prompt',
          'click',
        ].includes(value)
      },
    },
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    },
    filterList: {
      type: Array,
      default: () => {
        return [
          {
            id: 'id',
            label: 'label'
          }
        ]
      }
    },
    canCollapse: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(v) {
      this.$refs.filter.setCheckedKeys(v)
    }
  },
  methods: {
    changeFilter: _debounce(function() {
      const value = this.$refs.filter.getCheckedKeys()
        .filter((id) => id);

      setWindowHistory({
        query: {
          ...this.$route.query,
          [this.name]: value.join(',') || undefined
        }
      });

      this.$emit('input', value);

      if(this.type === 'prompt') {
        this.$emit('change', value);
      }
    }, 600),
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.baseFilter">
    <div
      v-if="!!title"
      class="baseFilter__title"
      :class="titleClass"
    >
      {{ title }}
    </div>
    <div>
      <el-tree
        ref="filter"
        :data="filterList"
        class="isStyleBase"
        :class="{ 'isStyleCollapse': canCollapse, 'isStyleDingBeauty': $globalIsDingBeauty }"
        show-checkbox
        default-expand-all
        :default-checked-keys="value"
        check-on-click-node
        :expand-on-click-node="false"
        node-key="id"
        @check-change="changeFilter"
      >
      </el-tree>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseFilter {
  @include max-md {
    margin-bottom: 2rem;
  }

  :global {
    .baseFilter {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.125rem;
        font-weight: 500;
      }
    }
  }
}
</style>
